function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true,
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

const closeSelector = (e) => e.removeAttribute("open");

(async () => {
  var e = await import(window.theme.modules.baseComponent);
  customElements.define(
    "form-custom-select",
    class extends e.default {
      constructor(...args) {
        super(...args);

        _defineProperty(this, "elements", {
          trigger: "[data-trigger]",
          tritterText: "[data-trigger-text]",
        });
      }

      render() {
        this.$trigger.addEventListener(
          "click",
          this._handleTriggerClick.bind(this)
        ),
          this.addEventListener("change", this._handleInputChange.bind(this));
      }

      _handleTriggerClick(e) {
        e.stopPropagation(),
          this.toggleAttribute("open"),
          document
            .querySelectorAll(this.tagName)
            .forEach(this._closeForeignSelector.bind(this));
      }

      _handleInputChange(e) {
        this.$tritterText.innerText = e.target.value;
      }

      _closeForeignSelector(e) {
        e !== this && closeSelector(e);
      }
    }
  );
})(),
  document.addEventListener("click", (e) => {
    document.querySelectorAll("form-custom-select").forEach(closeSelector);
  });
